<app-auth-login-create-form
  *ngIf="loginForm"
  [flagList]="flagList"
  [loginForm]="loginForm"
  [isChecked]="isRememberChecked"
  (eventSubmit)="signIn(loginForm.value)"
  (eventShowPassword)="changeInputType($event, 'password')"
  (eventRemember)="changeRemember()"
></app-auth-login-create-form>

<h2
  class="mu-layout-auth-sub-title"
  [innerHTML]="'page.login.terms.full' | translate: { terms: termsLinks?.terms, politics: termsLinks?.politics }"
></h2>

<app-auth-login-terms-modal [flagList]="flagList" [termsLinks]="termsLinks" [countryId]="countryId"></app-auth-login-terms-modal>
